export default "__VITE_ASSET__D8m7va1B__"